import Swiper from 'swiper/swiper-bundle';

class testimonialSliderSection {
  constructor(section) {
    this.section = section;

    this.initSlider();
  }

  initSlider() {
    const nextButton = this.section.querySelector('.js-testimonial-slider-section__button--next');
    const prevButton = this.section.querySelector('.js-testimonial-slider-section__button--prev');
    const pagination = this.section.querySelector('.js-testimonial-slider-section__pagination');

    this.slider = new Swiper(this.section.querySelector('.swiper-container'), {
      slidesPerView: 1.5,
      resizeObserver: true,
      loop: true,
      centeredSlides: true,
      slideToClickedSlide: true,
      navigation: {
        nextEl: nextButton,
        prevEl: prevButton,
      },
      pagination: {
        el: pagination,
        clickable: true
      },
      speed: 500,
      breakpoints: {
        768: {
          slidesPerView: 3,
          slideToClickedSlide: false,
        },
      },
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.js-testimonial-slider-section');

  if (!sections.length) return;

  sections.forEach(section => {
    new testimonialSliderSection(section);
  });
});